module.exports = __webpack_public_path__ + "assets/img/krzysztof-lawrywjaniec.fb42b4a7.jpg";